<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M4 15.9997H6.66681V8H4V15.9997Z"
		fill={getTailwindColor(color)}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M9.33375 16H14.6674V13.3334H9.33375V16Z"
		fill={getTailwindColor(color)}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M9.33319 10.6669H14.6668V8.00029H9.33319V10.6669Z"
		fill={getTailwindColor(color)}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M17.3332 15.9998H20V8.00007H17.3332V15.9998Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
